export default __webpack_public_path__ + "static/media/Path3539.175511b2.svg";